<template src="./template.html"></template>
<script>
/* eslint-disable */
export default {
  name: 'Select',
  props: ['list', 'placeholder', 'preselect', 'required', 'disable', 'forID'],
  data() {
    return {
      opened: false,
      name: '',
    };
  },
  methods: {
    openList() {
      if(this.disable) return;
      this.opened = !this.opened;
    },
    select(value, name) {
      this.name = name;
      this.opened = false;
      this.emitSelect(value, name);
    },
    emitSelect: function (value, name) {
      this.$emit('selectEmit', value, name, this);
    },
    blur(e){
      let el = this.$refs.selectBox;
      let target = e.target;
      if (( el !== target) && !el.contains(target)) {
        this.opened = false;
      }
    },
  },
  created () {
    if( this.preselect ){
      this.name = this.preselect;
    }else{
      this.name = this.placeholder;
    }
    document.addEventListener('click', this.blur)
  },
  watch: {
    preselect: function(newVal, oldVal){
      for(var ii=0; ii < this.list.length; ii++){
        if( this.list[ii].value === this.preselect){
          this.name = this.list[ii].name;
        }
      }
    },
  },
  destroyed () {
    document.removeEventListener('click', this.blur)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cmp/select/index.vue